import styled from '@emotion/styled'
import {css} from '@emotion/core'
import {mq} from '../../../../utils/breakpoints'

const triggerElementStyles = ({theme}) => css`
  background: ${theme.colors.preferenceSelectorBg};
  outline: none;
  display: flex;
  cursor: pointer;
  justify-content: center;
  align-items: center;
  border: 1px solid ${theme.colors.preferenceSelectorBorder};
  position: relative;
  height: ${theme.layout.spacing.s800}px;
  width: ${theme.layout.spacing.s300 * 7}px;
  font-family: ${theme.fonts.family.default};
  font-size: ${theme.fonts.size.md};
  line-height: ${theme.fonts.lineHeight.md};
  font-weight: ${theme.fonts.weight.lg};
  margin-left: -1px;

  &:first-child {
    border-top-left-radius: ${theme.layout.radius.sm}px;
    border-bottom-left-radius: ${theme.layout.radius.sm}px;
  }

  &:last-child {
    border-top-right-radius: ${theme.layout.radius.sm}px;
    border-bottom-right-radius: ${theme.layout.radius.sm}px;
  }
`

export const TriggerElement = styled('button')(triggerElementStyles)

// TODO: Disabled for enforcing lint, fix if possible
// eslint-disable-next-line no-undef
export const withBorderArrow = ({theme}: TsToDo) => css`
  &::before,
  &::after {
    display: block;
    content: '';
    position: absolute;
    width: ${theme.layout.spacing.s300}px;
    height: ${theme.layout.spacing.s300}px;
    transform: rotate(45deg);
    top: -4px;
    right: ${theme.layout.spacing.s600}px;
  }
  &::before {
    box-shadow: ${theme.shadows.fixed};
    z-index: -1;
  }
  &::after {
    background: ${theme.colors.preferencePopupBg};
    z-index: 1;
  }
`

const popupWrapperStyles = ({theme}) => css`
  position: absolute;
  background: ${theme.colors.preferencePopupBg};
  margin: -1px 0 0 0;
  min-width: 600px;
  max-width: 720px;
  text-align: left;
  font-family: ${theme.fonts.family.default};
  right: 0;
  top: 125%;
  box-shadow: ${theme.shadows.fixed};
  border-radius: 6px;

  ${mq.desktopSm(`
    max-width: none;
    width: 820px;
  `)};
`

export const PopupWrapper = styled('div')(popupWrapperStyles, withBorderArrow)

const listHeaderStyles = ({theme}) => css`
  margin: 0;
  border-bottom: 1px solid ${theme.colors.preferencePopupHeaderBorder};
  padding: ${theme.layout.spacing.s500}px;
  font-size: ${theme.fonts.size.lg};
  line-height: ${theme.fonts.lineHeight.lg};
  font-family: ${theme.fonts.family.default};
  text-transform: capitalize;
`

export const ListHeader = styled('h3')(listHeaderStyles)

const listStyles = ({theme}) => css`
  padding: 0;
  list-style: none;
  columns: 3;
  margin: ${theme.layout.spacing.s300}px;

  ${mq.desktopSm(`
    columns: 4;
  `)};
`

export const ListElement = styled('ul')(listStyles)

export const ListItemElement = styled('li')`
  white-space: nowrap;
  margin: 0;
  break-inside: avoid;
`

const withActiveLinkState = ({theme, isActive}) => {
  return (
    isActive &&
    css`
      background: ${theme.colors.preferencePopupActiveBg};
      color: ${theme.colors.preferencePopupActive};
      border-radius: 0;

      &:hover,
      &:visited,
      span {
        color: ${theme.colors.preferencePopupActive};
      }
    `
  )
}

const listLinkStyles = ({theme}) => css`
  display: flex;
  padding: ${theme.layout.spacing.s300}px;
  align-items: center;
  font-size: ${theme.fonts.size.md};
  line-height: ${theme.fonts.lineHeight.md};

  & * {
    vertical-align: top;
  }
`

export const ListLinkElement = styled('a')(listLinkStyles, withActiveLinkState)

export const NameElement = styled('span')`
  white-space: normal;
  display: inline-block;
`

export const CustomInputSelect = styled('select')(
  ({theme}) => css`
    opacity: 0;
    position: absolute;
    width: 100%;
    height: 100%;
    font-size: ${theme.fonts.size.md};
  `
)

export const WrapperSelector = styled('div')(
  () => css`
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: relative;
  `
)
